/**
 * @generated SignedSource<<237cacb8b5b7f0346ee6ee58240a0af2>>
 * @relayHash 93e52fbeb9de0a05ec4982ac1e0aecac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5d37d73adbd3a9cc6d79b10ac0a458fcaa19918b65f6029434a3375472417480

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraCFOSortOrder = "ASC" | "DESC" | "%future added value";
export type JiraCFOTimeGranularity = "DAY" | "FIFTEEN_MINUTES" | "HOUR" | "MINUTES_15" | "MONTH" | "WEEK" | "%future added value";
export type JiraCFOSortInput = {
  key?: string | null;
  order?: JiraCFOSortOrder | null;
};
export type LoadTimesTabQuery$variables = {
  cloudId: string;
  endDate: AGG$DateTime;
  granularity?: JiraCFOTimeGranularity | null;
  sortInput?: ReadonlyArray<JiraCFOSortInput | null> | null;
  startDate: AGG$DateTime;
};
export type LoadTimesTabQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"LoadTimesTab">;
};
export type LoadTimesTabQuery = {
  response: LoadTimesTabQuery$data;
  variables: LoadTimesTabQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v2 = {
  "defaultValue": "HOUR",
  "kind": "LocalArgument",
  "name": "granularity"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortInput"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v5 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v6 = {
  "kind": "Variable",
  "name": "endDate",
  "variableName": "endDate"
},
v7 = {
  "kind": "Variable",
  "name": "granularity",
  "variableName": "granularity"
},
v8 = {
  "kind": "Variable",
  "name": "sortInput",
  "variableName": "sortInput"
},
v9 = {
  "kind": "Variable",
  "name": "startDate",
  "variableName": "startDate"
},
v10 = {
  "kind": "Literal",
  "name": "dimensions",
  "value": [
    {
      "name": "apdexBucket"
    }
  ]
},
v11 = {
  "kind": "Literal",
  "name": "filters",
  "value": [
    {
      "dimensionFilter": {
        "name": "experienceKey",
        "operator": "IN",
        "values": [
          "jira.fe.page-load.classic-board",
          "jira.fe.page-load.next-gen-board",
          "jira.fe.page-load.issue-view",
          "jira.fe.page-load.issue-view-software",
          "jira.fe.page-load.issue-view-serviceDesk",
          "jira.fe.page-load.issue-view-core",
          "jira.fe.page-load.issue-view-polaris",
          "jira.fe.page-load.issue-view-platform",
          "jira.fe.page-load.issue-view-embed",
          "jira.fe.page-load.issue-view-addon",
          "jira.fe.page-load.issue-view-unknown",
          "jira.fe.page-load.issue-view-customer-service",
          "jira.fe.custom.embedded-issue-view-load",
          "jira.fe.page-load.classic-backlog",
          "jira.fe.page-load.next-gen-backlog"
        ]
      }
    }
  ]
},
v12 = {
  "kind": "Literal",
  "name": "isV2",
  "value": true
},
v13 = {
  "aggregation": {
    "type": "SUM"
  },
  "alias": "request_count",
  "name": "count"
},
v14 = {
  "kind": "Literal",
  "name": "metrics",
  "value": [
    (v13/*: any*/)
  ]
},
v15 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v16 = {
  "kind": "ScalarField",
  "name": "timestamp"
},
v17 = {
  "kind": "ScalarField",
  "name": "value"
},
v18 = [
  {
    "kind": "ScalarField",
    "name": "name"
  },
  (v17/*: any*/)
],
v19 = [
  (v15/*: any*/),
  {
    "concreteType": "JiraCFODataRowConnection",
    "kind": "LinkedField",
    "name": "data",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraCFODataRowEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              (v16/*: any*/),
              {
                "concreteType": "JiraCFODimension",
                "kind": "LinkedField",
                "name": "dimensions",
                "plural": true,
                "selections": (v18/*: any*/)
              },
              {
                "concreteType": "JiraCFOMetric",
                "kind": "LinkedField",
                "name": "metrics",
                "plural": true,
                "selections": [
                  (v17/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  }
],
v20 = {
  "kind": "Literal",
  "name": "filters",
  "value": [
    {
      "dimensionFilter": {
        "name": "experienceKey",
        "operator": "IN",
        "values": [
          "jira.fe.page-load.classic-board",
          "jira.fe.page-load.next-gen-board"
        ]
      }
    }
  ]
},
v21 = {
  "kind": "Literal",
  "name": "filters",
  "value": [
    {
      "dimensionFilter": {
        "name": "experienceKey",
        "operator": "IN",
        "values": [
          "jira.fe.page-load.issue-view",
          "jira.fe.page-load.issue-view-software",
          "jira.fe.page-load.issue-view-serviceDesk",
          "jira.fe.page-load.issue-view-core",
          "jira.fe.page-load.issue-view-polaris",
          "jira.fe.page-load.issue-view-platform",
          "jira.fe.page-load.issue-view-embed",
          "jira.fe.page-load.issue-view-addon",
          "jira.fe.page-load.issue-view-unknown",
          "jira.fe.page-load.issue-view-customer-service",
          "jira.fe.custom.embedded-issue-view-load"
        ]
      }
    }
  ]
},
v22 = {
  "kind": "Literal",
  "name": "filters",
  "value": [
    {
      "dimensionFilter": {
        "name": "experienceKey",
        "operator": "IN",
        "values": [
          "jira.fe.page-load.classic-backlog",
          "jira.fe.page-load.next-gen-backlog"
        ]
      }
    }
  ]
},
v23 = {
  "kind": "Literal",
  "name": "metrics",
  "value": [
    {
      "aggregation": {
        "type": "PERCENTILE",
        "value": 0.5
      },
      "alias": "load_time_p50",
      "name": "vc90"
    },
    {
      "aggregation": {
        "type": "PERCENTILE",
        "value": 0.75
      },
      "alias": "load_time_p75",
      "name": "vc90"
    },
    (v13/*: any*/)
  ]
},
v24 = [
  (v15/*: any*/),
  {
    "concreteType": "JiraCFODataRowConnection",
    "kind": "LinkedField",
    "name": "data",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraCFODataRowEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              (v16/*: any*/),
              {
                "concreteType": "JiraCFOMetric",
                "kind": "LinkedField",
                "name": "metrics",
                "plural": true,
                "selections": (v18/*: any*/)
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "LoadTimesTabQuery",
    "selections": [
      {
        "args": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "LoadTimesTab"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "LoadTimesTabQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              (v5/*: any*/)
            ],
            "concreteType": "JiraCFOConfigsResult",
            "kind": "LinkedField",
            "name": "cfoConfigs",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraCFOLoadTimeConfig",
                "kind": "LinkedField",
                "name": "loadTimeConfig",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "lowerThreshold"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "higherThreshold"
                  }
                ]
              }
            ]
          },
          {
            "alias": "aggregated",
            "args": [
              (v5/*: any*/),
              (v10/*: any*/),
              (v6/*: any*/),
              (v11/*: any*/),
              (v7/*: any*/),
              (v12/*: any*/),
              (v14/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": (v19/*: any*/)
          },
          {
            "alias": "boards",
            "args": [
              (v5/*: any*/),
              (v10/*: any*/),
              (v6/*: any*/),
              (v20/*: any*/),
              (v7/*: any*/),
              (v12/*: any*/),
              (v14/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": (v19/*: any*/)
          },
          {
            "alias": "workItems",
            "args": [
              (v5/*: any*/),
              (v10/*: any*/),
              (v6/*: any*/),
              (v21/*: any*/),
              (v7/*: any*/),
              (v12/*: any*/),
              (v14/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": (v19/*: any*/)
          },
          {
            "alias": "backlogs",
            "args": [
              (v5/*: any*/),
              (v10/*: any*/),
              (v6/*: any*/),
              (v22/*: any*/),
              (v7/*: any*/),
              (v12/*: any*/),
              (v14/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": (v19/*: any*/)
          },
          {
            "alias": "aggregatedPercentile",
            "args": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v11/*: any*/),
              (v7/*: any*/),
              (v12/*: any*/),
              (v23/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": (v24/*: any*/)
          },
          {
            "alias": "boardsPercentile",
            "args": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v20/*: any*/),
              (v7/*: any*/),
              (v12/*: any*/),
              (v23/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": (v24/*: any*/)
          },
          {
            "alias": "workItemsPercentile",
            "args": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v21/*: any*/),
              (v7/*: any*/),
              (v12/*: any*/),
              (v23/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": (v24/*: any*/)
          },
          {
            "alias": "backlogsPercentile",
            "args": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v22/*: any*/),
              (v7/*: any*/),
              (v12/*: any*/),
              (v23/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": (v24/*: any*/)
          }
        ]
      }
    ]
  },
  "params": {
    "id": "5d37d73adbd3a9cc6d79b10ac0a458fcaa19918b65f6029434a3375472417480",
    "metadata": {},
    "name": "LoadTimesTabQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "faf0e3b7e9ffdb2c5360c2bdfc76e4db";

export default node;
